import React, { useState, useEffect } from 'react';
import Hero from './components/Hero';
import BuyerTargets from './components/BuyerTargets';
import DomainValue from './components/DomainValue';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ZaptBadge from './components/ZaptBadge';

export default function App() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-deep-charcoal text-white overflow-x-hidden">
      <div className={`transition-opacity duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <Hero />
        <BuyerTargets />
        <DomainValue />
        <Contact />
        <Footer />
        <ZaptBadge />
      </div>
    </div>
  );
}